import defaultAttributes from '../defaultAttributes';

const Video = [
  'svg',
  defaultAttributes,
  [
    ['polygon', { points: '23 7 16 12 23 17 23 7' }],
    ['rect', { x: '1', y: '5', width: '15', height: '14', rx: '2', ry: '2' }],
  ],
];

export default Video;
